import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { Menu } from 'lucide-react';

import useMobileViewport from '../../hooks/useMobileViewport';

/**
 * @param {{
 *  children: import('react').ReactNode,
 *  hideTopBar?: boolean,
 *  topSlot?: import('react').ReactNode,
 *  disableMainPadding?: boolean,
 *  mainClassName?: string
 * }} props
 */
const DashboardLayout = ({
  children,
  hideTopBar = false,
  topSlot = null,
  disableMainPadding = false,
  mainClassName = ''
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Custom hook for stable mobile viewport & keyboard handling
  useMobileViewport();

  // Evita scroll del contenuto sotto al drawer su mobile
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isMobileMenuOpen]);

  return (
    <div
      className="flex bg-background/70 backdrop-blur-xl text-foreground overflow-hidden"
      style={{ height: '100dvh' }}
    >
      <Sidebar isMobileMenuOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
      <div className="flex-1 flex flex-col overflow-hidden w-full lg:w-auto">
        {!hideTopBar ? <Header onToggleSidebar={() => setIsMobileMenuOpen((v) => !v)} /> : null}

        {hideTopBar && (
          <button
            type="button"
            onClick={() => setIsMobileMenuOpen(true)}
            className="lg:hidden fixed top-3 left-3 z-30 p-2 rounded-xl border border-border bg-background/80 backdrop-blur-md shadow-sm hover:bg-accent transition-colors"
            aria-label="Apri menu"
          >
            <Menu className="w-5 h-5 text-foreground" />
          </button>
        )}

        {topSlot}

        <main
          className={`scrollArea flex-1 overflow-y-auto bg-transparent text-foreground ${disableMainPadding ? '' : 'p-4 md:p-6 lg:p-8'
            } ${hideTopBar ? 'mt-0' : 'mt-16 md:mt-16'} ${mainClassName}`}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;